/*
 * @Author: yejianfei
 * @Date: 2023-04-06 12:12:19
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-04-22 15:19:17
 * @Description:
 * @Developer:
 */
import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import Api from '../../api';
const api = Api();
export default function APISelect(props) {
    const [options, setOptions] = useState(props.options);
    useEffect(() => {
        if (props.loader) {
            api.get(props.loader, { params: props.params })
                .then((data) => setOptions(data));
        }
    }, []);
    useEffect(() => {
        if (props.loader) {
            api.get(props.loader, { params: props.params })
                .then((data) => setOptions(data));
        }
    }, [props.params]);
    const onSearch = (value) => {
        if (props.loader && props.searchParamName) {
            const params = Object.assign({}, (props.params || {}));
            params[props.searchParamName] = value;
            api.get(props.loader, { params })
                .then((data) => setOptions(data));
        }
        else {
            props.onSearch && props.onSearch(value);
        }
    };
    const attributes = Object.assign(Object.assign({}, props), { onSearch, options });
    delete attributes.searchParamName;
    return (React.createElement(Select, Object.assign({}, attributes, { filterOption: props.filterOption || !props.showSearch })));
}
